import { Row } from '@lightningjs/ui-components';
import { getSingleSeries, getSingleSeriesInfo } from '../../../api/series';
import SeriesComponent from '../components/SeriesComponent';

export default function (page, { seriesId }) {
  localStorage.setItem('seriesId', seriesId);
  // Fetch the single series data
  return getSingleSeries(seriesId)
    .then((response) => {
      if (!response?.data) {
        page._ErrorMessage.visible = true;
        page._Column.items = [];
        page.isUndefined = true;
        return; // Return early if data is undefined
      }

      const series = response.data;
      const { last_watched_movie_id } = series;

      let movie = null;

      if (last_watched_movie_id) {
        // Find the movie with last_watched_movie_id
        for (const item of series.data) {
          movie = item.movies.find((m) => m.id === last_watched_movie_id);
          if (movie) break;
        }
      }
      // If last_watched_movie_id is null or the movie was not found, take the first movie of the first series
      if (!movie && series.data?.length > 0) {
        movie = series.data[0].movies[0];
      }

      // If no movie is found or available, return early and show an error
      if (!movie) {
        page._ErrorMessage.visible = true;
        page._Column.items = [];
        page.isUndefined = true;
        return;
      }
      const hasResumeTime = movie.resume_time !== '0' && Number(movie.resume_time) > 0;
      const seriesLinks = [
        {
          id: 0,
          title: hasResumeTime ? 'Resume' : 'Play',
          image: hasResumeTime
            ? '/images/movie-info-icons/resume.svg'
            : '/images/movie-info-icons/play.svg',
          width: 500,
        },
        {
          id: 1,
          title: 'Play from beginning',
          image: '/images/movie-info-icons/play.svg',
          width: 500,
        },
        {
          id: 2,
          title: 'More Episodes',
          image: '/images/movie-info-icons/more-episodes.svg',
          width: 500,
        },
        {
          id: 3,
          title: 'Audio & Subtitles',
          image: '/images/movie-info-icons/subtitles.svg',
          width: 500,
        },
        {
          id: 4,
          title: series.on_watchlist ? 'Added from My List' : 'Add to My List',
          image: '/images/movie-info-icons/my-list.svg',
          width: 500,
        },
        {
          id: 5,
          title: '',
          image: '/images/movie-info-icons/thumb-up.svg',
          width: 200,
        },
        {
          id: 6,
          title: '',
          image: '/images/movie-info-icons/thumb-down.svg',
          width: 200,
        },
      ];

      // Filter out 'Resume' link if resume_time is '0'
      const filteredSeriesLinks = hasResumeTime
        ? seriesLinks
        : seriesLinks.filter((link) => link.id !== 0);

      // Fetch additional series info concurrently
      return Promise.all([
        Promise.resolve(filteredSeriesLinks), // Keep this resolved value
        getSingleSeriesInfo(movie.id), // Fetch series info
      ]).then(([links, seriesInfoData]) => {
        const items = links.map((link, index) => ({
          w: 210,
          h: 70,
          index,
          collision: true,
          type: SeriesComponent,
          movieInfo: series,
          movieLink: link,
          serieId: movie.id,
          seriesData: seriesInfoData.data.movie,
        }));

        if (items.length > 1) {
          const lastIndex = items.length - 1;
          items[lastIndex - 1] = {
            type: Row,
            collision: true,
            items: [items[lastIndex - 1], items[lastIndex]],
          };
          items.pop(); // Remove the last item since it's now nested in a Row
        }

        // Update page state
        page._ErrorMessage.visible = false;
        page.isUndefined = false;
        page._Column.items = items;
      });
    })
    .catch((error) => {
      console.error('Error fetching SERIES data:', error);
      page._ErrorMessage.visible = true;
      page._Column.items = [];
      page.isUndefined = true;
    });
}
